import { resultDetailsActionTypes } from './Constants';
import shortid from 'shortid';

const initialState = {
	loading: false,
	words_with_performance: [],
	prioritizedLanguage: '',
	orderOptions: [],
	exerciseTypes: [],
	orderedSections: [
		'Fout',
		'Meestal fout',
		'Soms fout',
		'Meestal goed',
		'Goed',
		'Nog niet geoefend',
	],
	ratingModal: {
		open: false,
	},
};

export default function resultDetailsReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, error, exerciseTypes } = payload || {};

	switch (type) {
		case resultDetailsActionTypes.GET_RESULT_DETAILS_REQUEST:
		case resultDetailsActionTypes.GET_EXERCISE_TYPES_REQUEST:
			return {
				...state,
				loading: true,
			};

		case resultDetailsActionTypes.GET_RESULT_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				...data,
				words_with_performance: data.words_with_performance.map((item) => ({
					...item,
					id: shortid.generate(),
					isChecked: false,
				})),
				prioritizedLanguage: data.prioritized_language && data.prioritized_language.locale,
			};

		case resultDetailsActionTypes.GET_EXERCISE_TYPES_SUCCESS:
			return {
				...state,
				loading: false,
				exerciseTypes,
			};

		case resultDetailsActionTypes.GET_RESULT_DETAILS_ERROR:
		case resultDetailsActionTypes.GET_EXERCISE_TYPES_ERROR:
			return {
				...state,
				loading: false,
			};

		case resultDetailsActionTypes.OPEN_RATING_MODAL:
			return {
				...state,
				ratingModal: {
					open: true,
				},
			};

		case resultDetailsActionTypes.CLEAN_EXERCISE_TYPES_STATE:
			return initialState;

		default:
			return state;
	}
}
